/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Col_RangeInputs */

const en_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range`)
};

const de_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanne`)
};

const fr_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fourchette`)
};

const es_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango`)
};

const it_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fascia`)
};

const nl_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereik`)
};

const pl_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakres`)
};

const fi_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihteluväli`)
};

const da_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spænd`)
};

const sv_salary_col_range = /** @type {(inputs: Salary_Col_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spann`)
};

/**
* | output |
* | --- |
* | "Range" |
*
* @param {Salary_Col_RangeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_col_range = /** @type {((inputs?: Salary_Col_RangeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Col_RangeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_col_range(inputs)
	if (locale === "fr") return fr_salary_col_range(inputs)
	if (locale === "es") return es_salary_col_range(inputs)
	if (locale === "it") return it_salary_col_range(inputs)
	if (locale === "nl") return nl_salary_col_range(inputs)
	if (locale === "pl") return pl_salary_col_range(inputs)
	if (locale === "fi") return fi_salary_col_range(inputs)
	if (locale === "da") return da_salary_col_range(inputs)
	if (locale === "sv") return sv_salary_col_range(inputs)
	return en_salary_col_range(inputs)
});